import { useEffect } from 'react';

const APP_NAME = 'Suturia';

/** Sets `document.title` to `"<segment> · Suturia"` and restores on unmount. */
export function useDocumentTitle(segment: string | undefined) {
  useEffect(() => {
    const prev = document.title;
    document.title = segment ? `${segment} · ${APP_NAME}` : APP_NAME;
    return () => {
      document.title = prev;
    };
  }, [segment]);
}
